import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiService } from '../services/api'

// 异步 thunks
export const fetchMetrics = createAsyncThunk(
  'monitor/fetchMetrics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.monitor.getMetrics()
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.apiMessage || '获取系统指标失败')
    }
  }
)

export const fetchHealth = createAsyncThunk(
  'monitor/fetchHealth',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.monitor.getHealth()
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.apiMessage || '获取健康状态失败')
    }
  }
)

export const fetchAuditLogs = createAsyncThunk(
  'monitor/fetchAuditLogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.audit.getLogs(params)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.apiMessage || '获取审计日志失败')
    }
  }
)

const initialState = {
  metrics: null,
  health: null,
  auditLogs: {
    logs: [],
    total: 0,
    page: 1,
    page_size: 20,
  },
  loading: {
    metrics: false,
    health: false,
    auditLogs: false,
  },
  error: {
    metrics: null,
    health: null,
    auditLogs: null,
  },
}

const monitorSlice = createSlice({
  name: 'monitor',
  initialState,
  reducers: {
    clearError: (state, action) => {
      const { type } = action.payload
      if (type) {
        state.error[type] = null
      } else {
        state.error = {
          metrics: null,
          health: null,
          auditLogs: null,
        }
      }
    },
    clearMetrics: (state) => {
      state.metrics = null
    },
    clearHealth: (state) => {
      state.health = null
    },
  },
  extraReducers: (builder) => {
    // fetchMetrics
    builder
      .addCase(fetchMetrics.pending, (state) => {
        state.loading.metrics = true
        state.error.metrics = null
      })
      .addCase(fetchMetrics.fulfilled, (state, action) => {
        state.loading.metrics = false
        state.metrics = action.payload
      })
      .addCase(fetchMetrics.rejected, (state, action) => {
        state.loading.metrics = false
        state.error.metrics = action.payload
      })

    // fetchHealth
    builder
      .addCase(fetchHealth.pending, (state) => {
        state.loading.health = true
        state.error.health = null
      })
      .addCase(fetchHealth.fulfilled, (state, action) => {
        state.loading.health = false
        state.health = action.payload
      })
      .addCase(fetchHealth.rejected, (state, action) => {
        state.loading.health = false
        state.error.health = action.payload
      })

    // fetchAuditLogs
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.loading.auditLogs = true
        state.error.auditLogs = null
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.loading.auditLogs = false
        state.auditLogs = action.payload
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.loading.auditLogs = false
        state.error.auditLogs = action.payload
      })
  },
})

export const { clearError, clearMetrics, clearHealth } = monitorSlice.actions

export default monitorSlice.reducer

// 选择器
export const selectMetrics = (state) => state.monitor.metrics
export const selectHealth = (state) => state.monitor.health
export const selectAuditLogs = (state) => state.monitor.auditLogs
export const selectMonitorLoading = (state) => state.monitor.loading
export const selectMonitorError = (state) => state.monitor.error
